import { useEffect } from 'react';

/**
 * Hook to detect when the browser window gains focus
 *
 * Used to trigger the call completion prompt when a provider
 * returns to MedArrive after conducting a telehealth call in
 * a separate window.
 *
 * @param onFocus - Callback to execute when window gains focus
 * @param enabled - Whether the hook should be active
 */
export function useWindowFocus(onFocus: () => void, enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    const handleFocus = () => {
      onFocus();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [onFocus, enabled]);
}
